/**
 * Utility functions for managing recent dashboards
 */

const RECENT_DASHBOARDS_KEY = 'recentDashboards';
const MAX_RECENT_DASHBOARDS = 10;

/**
 * Save a dashboard to the recent dashboards list
 * @param {Object} projectData - Project data object with at least: projectId, projectName, opportunityNo
 */
export const saveRecentDashboard = (projectData) => {
  try {
    const recentDashboards = getRecentDashboards();
    
    // Remove if already exists (to avoid duplicates)
    const filtered = recentDashboards.filter(
      (d) => d.projectId !== projectData.projectId && d.opportunityNo !== projectData.opportunityNo
    );
    
    // Add to the beginning
    const updated = [
      {
        projectId: projectData.projectId || projectData.id_project,
        projectName: projectData.projectName || projectData.name || 'Unknown Project',
        opportunityNo: projectData.opportunityNo || projectData.opportunityUUID,
        opportunityId: projectData.id_project || projectData.Id, // Store the Salesforce Id for fetching
        timestamp: new Date().toISOString(),
        department: projectData.department || projectData.dv_Division_New__c || projectData.division || 'Engineered Fill'
      },
      ...filtered
    ].slice(0, MAX_RECENT_DASHBOARDS); // Keep only the most recent 10
    
    localStorage.setItem(RECENT_DASHBOARDS_KEY, JSON.stringify(updated));
    return updated;
  } catch (error) {
    console.error('Error saving recent dashboard:', error);
    return [];
  }
};

/**
 * Get recent dashboards from localStorage
 * @returns {Array} Array of recent dashboard objects
 */
export const getRecentDashboards = () => {
  try {
    const stored = localStorage.getItem(RECENT_DASHBOARDS_KEY);
    return stored ? JSON.parse(stored) : [];
  } catch (error) {
    console.error('Error getting recent dashboards:', error);
    return [];
  }
};

/**
 * Clear all recent dashboards
 */
export const clearRecentDashboards = () => {
  try {
    localStorage.removeItem(RECENT_DASHBOARDS_KEY);
  } catch (error) {
    console.error('Error clearing recent dashboards:', error);
  }
};

